export default __webpack_public_path__ + "static/pre_policy_issuance_process-5b3fee102016744ba73fa52972a55932.pdf";